'use strict';

import animationsUtility from '../utility/animations.js'

const init = () => {
    document.querySelectorAll('.tc-website-scrollingcustomers').forEach((scrollingCustomers) => {
        animationsUtility.animateScrollingCustomers(scrollingCustomers)
    })
}

export default {init}
